import { Helmet } from 'react-helmet'
import GoodCheapFast from './GoodCheapFast'

const Wrapper = () => (
  <>
    <Helmet>
      <meta charSet='utf-8' />
      <title>Good, Cheap, Fast</title>
    </Helmet>
    <GoodCheapFast />
  </>
)
export default Wrapper
